import React, { useEffect, useState } from 'react';
import './ReportsView.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faArrowLeftLong, } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from "react-router-dom";


const config=require( '../../config.js');

function ReportsThirdUser() {
    const [Reports, setReports] = useState([]);
    const navigate = useNavigate();
    

    const fetchReports = async () => {
        try {
            const response = await fetch(config.env.API_BASE_URL + '/api/reports/thirds/users', {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                const data = await response.json();
                setReports(data);
            } else {
                console.error('Failed to fetch Reports');
            }
        } catch (error) {
            console.error('Error fetching Reports:', error);
        }
    };

    useEffect(() => {
        fetchReports(); // Fetch Reports on component mount
    }, []);

    const GoToReports = (userId) => {
        navigate(`/reports/third/view/${userId}`);
    };
const GoBack = () => {
    window.history.back();
  }
    return (
        <>
        
            <div className='mt-5 Crud-main-container container'>
                <table className="table Crud-main container">
                    <thead>
                        <tr className="Crud-thead-wrapper">
                            <th scope="col">Company</th>
                            <th scope="col">Email</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Reports
                            .slice()
                            .map((report) => (
                                <tr key={report._id}>
                                    <td>{report.company}</td>
                                    <td>{report.email}</td>
                                    <td>
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            onClick={() => {
                                                GoToReports(report._id);
                                            }}
                                        />
                                    </td>
                                </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default ReportsThirdUser;
